module.exports = __webpack_public_path__ + "img/CI.87684ac3.png";